<div class="app-shell">

  <header>
    <mat-toolbar *ngIf="logado | async as isLogged">

      <button *ngIf="isLogged" mat-icon-button (click)="sidenav.toggle()" aria-label="Abrir menu">
        <mat-icon aria-hidden="true">menu</mat-icon>
      </button>

      <span routerLink="relatorio" class="col-lg-2 col-md-2 col-sm-3 col-xs-3">
        <img src="assets/images/logoBranco2.png" class="w-100" alt="">
      </span>

    </mat-toolbar>
  </header>

  <main>
    <mat-sidenav-container>

      <mat-sidenav #sidenav mode="over">

      <mat-nav-list>

        <!-- Relatórios -->
        <mat-expansion-panel>
          <mat-expansion-panel-header class="flex-row">
            <mat-icon class="mr-2" aria-hidden="true">description</mat-icon>
            Relatórios
          </mat-expansion-panel-header>

          <a mat-list-item routerLink="relatorio/dashboard" (click)="sidenav.close()">
            <mat-icon class="mr-2" aria-hidden="true">dashboard</mat-icon>
            Indicadores
          </a>

          <a mat-list-item routerLink="relatorio/relatorio-chamadas" (click)="sidenav.close()">
            <mat-icon class="mr-2" aria-hidden="true">call</mat-icon>
            Chamadas
          </a>

          <a mat-list-item routerLink="relatorio/relatorio-callcenter" (click)="sidenav.close()">
            <mat-icon class="mr-2" aria-hidden="true">headset_mic</mat-icon>
            Callcenter
          </a>

          <!-- Agente submenu -->
          <div class="submenu-toggle" (click)="relAgenteOpen = !relAgenteOpen">
            <mat-icon class="mr-2" aria-hidden="true">people</mat-icon>
            <span>Agente</span>
            <mat-icon class="toggle-arrow" aria-hidden="true">{{ relAgenteOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
          <ng-container *ngIf="relAgenteOpen">
            <a mat-list-item class="submenu-item" routerLink="relatorio/relatorio-agentes" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">people</mat-icon>
              Receptivo
            </a>
            <a mat-list-item class="submenu-item" routerLink="relatorio/relatorio-agentes-chamadas" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">bar_chart</mat-icon>
              Comparativo
            </a>
            <a mat-list-item class="submenu-item" routerLink="relatorio/pausas" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">pause_circle</mat-icon>
              Pausas
            </a>
          </ng-container>

          <a mat-list-item routerLink="relatorio/relatorio-gravacoes" (click)="sidenav.close()">
            <mat-icon class="mr-2" aria-hidden="true">mic</mat-icon>
            Gravações
          </a>

        </mat-expansion-panel>

        <!-- Online -->
        <mat-expansion-panel *ngIf="on | async">

          <mat-expansion-panel-header class="flex-row">

            <mat-icon class="mr-2" aria-hidden="true">podcasts</mat-icon>
            Online
          </mat-expansion-panel-header>

          <a mat-list-item routerLink="online" (click)="sidenav.close()">
            <mat-icon class="mr-2" aria-hidden="true">dialpad</mat-icon>
            Ramais
          </a>

          <!-- Callcenter submenu -->
          <div class="submenu-toggle" (click)="callcenterOpen = !callcenterOpen">
            <mat-icon class="mr-2" aria-hidden="true">headset_mic</mat-icon>
            <span>Callcenter</span>
            <mat-icon class="toggle-arrow" aria-hidden="true">{{ callcenterOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
          <ng-container *ngIf="callcenterOpen">
            <a mat-list-item class="submenu-item" routerLink="online/filas" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">headset_mic</mat-icon>
              Geral
            </a>
            <a mat-list-item class="submenu-item" href="/online/filas-tv" target="_blank" rel="noopener" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">tv</mat-icon>
              Modo TV
            </a>
          </ng-container>

          <!-- Agentes submenu -->
          <div class="submenu-toggle" (click)="agentesOpen = !agentesOpen">
            <mat-icon class="mr-2" aria-hidden="true">group</mat-icon>
            <span>Agentes</span>
            <mat-icon class="toggle-arrow" aria-hidden="true">{{ agentesOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </div>
          <ng-container *ngIf="agentesOpen">
            <a mat-list-item class="submenu-item" routerLink="online/membros" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">group</mat-icon>
              Geral
            </a>
            <a mat-list-item class="submenu-item" href="/online/membros-tv" target="_blank" rel="noopener" (click)="sidenav.close()">
              <mat-icon class="mr-2 submenu-icon" aria-hidden="true">tv</mat-icon>
              Modo TV
            </a>
          </ng-container>

        </mat-expansion-panel>

        <!-- Diretórios -->
        <a *ngIf="dir | async" mat-list-item routerLink="diretorios" (click)="sidenav.close()">
          <mat-icon class="mr-2" aria-hidden="true">folder</mat-icon>
          Diretórios
        </a>

        <a mat-list-item routerLink="conta" (click)="sidenav.close()">
          <mat-icon class="mr-2" aria-hidden="true">account_circle</mat-icon>
          Conta
        </a>

        <a mat-list-item routerLink="ajuda" (click)="sidenav.close()">
          <mat-icon class="mr-2" aria-hidden="true">help_outline</mat-icon>
          Ajuda
        </a>

        <a mat-list-item (click)="confirmarLogoff(sidenav)">
          <mat-icon class="mr-2" aria-hidden="true">logout</mat-icon>
          Logoff
        </a>

        <span mat-list-item class="footer-side">
          <mat-icon class="mr-2" aria-hidden="true">info</mat-icon>
          v.<strong>{{ version }}</strong>
        </span>


      </mat-nav-list>

    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>

    </mat-sidenav-container>
  </main>

</div>
